import { render } from "./MySideBarStundent.vue?vue&type=template&id=5ab67870"
import script from "./MySideBarStundent.vue?vue&type=script&lang=js"
export * from "./MySideBarStundent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__